import React from "react";
import {
  Typography, Grid, TextField, Switch, FormControlLabel,
  Accordion, AccordionSummary, AccordionDetails
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SelectConAggiunta from "../SelectConAggiunta";

export default function SezioneDR({ form, handleChange, canaliDR, loadingCanali, aggiungiCanale }) {
  return (
    <Accordion defaultExpanded elevation={1} sx={{ mb: 2 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: "#E1F5EE" }}>
        <Typography fontWeight="bold">D&R e Chat</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2} mt={0}>
          <Grid item xs={12} md={4}>
            <FormControlLabel control={<Switch checked={form.chatAttiva}
              onChange={(e) => handleChange("chatAttiva", e.target.checked)} />}
              label="Chat attiva" />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControlLabel control={<Switch checked={form.drAttiva}
              onChange={(e) => handleChange("drAttiva", e.target.checked)} />}
              label="D&R attiva" />
          </Grid>
          <Grid item xs={12} md={4}>
            <FormControlLabel control={<Switch checked={form.liberatoriaRelatori}
              onChange={(e) => handleChange("liberatoriaRelatori", e.target.checked)} />}
              label="Liberatoria relatori esterni" />
          </Grid>
          {form.drAttiva && (
            <>
              <Grid item xs={12} md={6}>
                <TextField fullWidth label="Chi filtra D&R" value={form.chiFiltraDR}
                  onChange={(e) => handleChange("chiFiltraDR", e.target.value)} />
              </Grid>
              <Grid item xs={12} md={6}>
                <SelectConAggiunta label="Canale trasmissione a moderatore"
                  value={form.canaleDR || ""}
                  onChange={(v) => handleChange("canaleDR", v)}
                  items={canaliDR} loading={loadingCanali}
                  onAggiungi={aggiungiCanale} />
              </Grid>
            </>
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}